import { Package } from "lucide-react"

export function StockTableEmpty() {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <Package className="h-12 w-12 text-muted-foreground mb-4" />
      <h3 className="text-lg font-semibold">No stock data found</h3>
      <p className="text-muted-foreground text-center">
        Stock data will appear here once products are added to inventory.
      </p>
    </div>
  )
}
